<nz-modal
  [nzWidth]="'1000px'"
  [(nzVisible)]="isVisible"
  (nzVisibleChange)="onIsVisibleChange($event)"
  [nzTitle]="'Let’s customize your first call scenario!'"
  [nzMaskClosable]="false"
  [nzClosable]="false"
>
  <ng-container *nzModalContent>
    <nz-progress [nzPercent]="currentProgress()" nzStrokeColor="#1890ff"></nz-progress>
    <div [@stepTransition]="currentStepIndex()" class="modal-content">
      @switch (currentStepIndex()) {
        @case (0) {
          <div class="step-content">
            <h3 class="is-required">1. What product or service are you looking to sell?</h3>
            <textarea
              [nzSize]="'large'"
              nz-input
              [(ngModel)]="surveyData.productOrServiceToSell"
              (ngModelChange)="saveSurveyResponse()"
              placeholder="The more descriptive the better! For example: Peak Mojo - We are an AI-powered sales training tool designed to revolutionize the sales training process through hyper-realistic role-playing simulations. Our platform leverages AI and voice interactions to provide experiential learning that closely mimics actual sales call scenarios."
              [nzAutosize]="{ minRows: 7, maxRows: 10 }"
            ></textarea>

            <nz-divider nzPlain nzText="or select from Peak Mojo sample products"></nz-divider>

            <div class="horizontal">
              <button
                class="fit-content right"
                [nzSize]="'large'"
                nz-button
                nzType="default"
                [matTooltip]="'Click to apply'"
                [nzLoading]="isLoading()"
                (click)="onFillOutProductClick()"
              >
                Peak Mojo - Peak sales performance with AI-native experiential learning
              </button>
            </div>
          </div>
        }
        @default {
          <div class="vertical thanks-section">
            <h2>Thank You for Trying Our Product!</h2>
            <div>Click the green call button to try our AI Customer!</div>

            <div class="horizontal">
              @if (isLoading()) {
                <nz-skeleton class="card-placeholder" [nzActive]="true"></nz-skeleton>
              } @else {
                <!-- <app-session-template-card [sessionTemplate]="sessionTemplate()"></app-session-template-card> -->
              }
            </div>
          </div>
        }
      }
    </div>
  </ng-container>

  <div *nzModalFooter class="horizontal">
    <div class="horizontal">
      <!-- @if (currentStepIndex() < totalSteps) {
        <button
          [nzSize]="'large'"
          [disabled]="currentStepIndex() === 0"
          nz-button
          [nzLoading]="isLoading()"
          nzType="default"
          (click)="onPreviousClick()"
        >
          Previous
        </button>
      } -->
      @if (currentStepIndex() < totalSteps - 1) {
        <button
          [nzSize]="'large'"
          [disabled]="currentStepIndex() === totalSteps"
          nz-button
          [nzLoading]="isLoading()"
          nzType="primary"
          (click)="onNextClick()"
        >
          Next
        </button>
      } @else if (currentStepIndex() === totalSteps - 1) {
        <button [nzSize]="'large'" nz-button [nzLoading]="isLoading()" nzType="primary" (click)="onFinishClick()">
          Start Your First Scenario!
        </button>
      } @else if (currentStepIndex() === totalSteps) {
        <button [nzSize]="'large'" nz-button [nzLoading]="isLoading()" nzType="default" (click)="onCancelClick()">
          @if (isLoading()) {
            Initializing...
          } @else {
            Cancel
          }
        </button>
      }
    </div>
  </div>
</nz-modal>
